import { EventMessage } from './EventMessage';

export default EventMessage;
